module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DD79_1SE_HND.975007d9.jpg";